import React, { useState, useEffect } from 'react';
import httpApis from '../../services/HttpApis';
import { useNavigate } from 'react-router-dom';
import truncateProfileName from '../Truncation';
import { MdKeyboardArrowLeft } from 'react-icons/md';

function EditProfile() {
    const [selectedAvatar, setSelectedAvatar] = useState(null);
    const [avatars, setAvatars] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchAvatars = async () => {
            try {
                const response = await httpApis.getAllProfile();

                if (response.data && response.data.data) {
                    setAvatars(response.data.data);
                }
            } catch (error) {
                console.error("Error fetching avatars:", error);
            }
        };
        fetchAvatars();
    }, []);

    const handleAvatarClick = async (avatarId) => {
        setSelectedAvatar(avatarId);
        try {
            await httpApis.getSingleProfile(avatarId);

            // Save selected avatar ID and name in localStorage
            localStorage.setItem('selectedAvatar', avatarId);
            const selected = avatars.find(a => a.id === avatarId);
            if (selected) {
                localStorage.setItem('selectedAvatarName', selected.name || 'User');
            }

            // Redirect to updateProfile page
            navigate("/updateProfile");
        } catch (error) {
            console.error("Error setting profile:", error);
            alert("Failed to set profile. Please try again.");
        }
    };

    return (
        <div className="profile-container">
            <div className="profile-content">
                <h1 className="profile-title">
                    Edit Profile
                </h1>
                <div className="avatar-container">
                    {avatars.map((avatar) => (
                        <div key={avatar.id} className="avatar-wrapper">
                            <button
                                onClick={() => handleAvatarClick(avatar.id)}
                                className={`avatar-button ${selectedAvatar === avatar.id ? 'selected' : ''}`}
                            >
                                <img
                                    src={avatar.image_url || avatar.avatar_img}
                                    alt={avatar.name || `Avatar ${avatar.id}`}
                                    className="avatar-image"
                                />
                            </button>
                            <p className="avatar-name">{truncateProfileName(avatar.name || 'User')}</p>
                        </div>
                    ))}

                </div>
                <div className="paraText clickable" onClick={() => {
                    navigate("/profile")
                }} style={{ cursor: "pointer" }}>
                    <span><MdKeyboardArrowLeft className="arrowIcon" /></span> Go Back
                </div>
            </div>
        </div>
    );
}

export default EditProfile;